// Device fingerprint generator for anti-fraud system
// Combines Canvas, WebGL, hardware info into a single SHA-256 hash

const generateFingerprint = async () => {
  const components = [];

  // 1. Canvas fingerprint
  try {
    const canvas = document.createElement('canvas');
    canvas.width = 256;
    canvas.height = 128;
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillStyle = '#f60';
    ctx.fillRect(50, 10, 150, 80);
    ctx.fillStyle = '#069';
    ctx.fillText('CountryScanner FP', 2, 15);
    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
    ctx.fillText('AntiCheat v1', 4, 45);
    ctx.beginPath();
    ctx.arc(100, 80, 30, 0, Math.PI * 2);
    ctx.fillStyle = '#a33';
    ctx.fill();
    components.push('c:' + canvas.toDataURL());
  } catch (e) {
    components.push('c:err');
  }

  // 2. WebGL GPU info
  try {
    const gl = document.createElement('canvas').getContext('webgl');
    if (gl) {
      const dbg = gl.getExtension('WEBGL_debug_renderer_info');
      if (dbg) {
        components.push('gpu:' + gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL));
        components.push('gpuv:' + gl.getParameter(dbg.UNMASKED_VENDOR_WEBGL));
      }
    }
  } catch (e) {
    components.push('gpu:err');
  }

  // 3. Hardware
  components.push('cores:' + (navigator.hardwareConcurrency || 0));
  components.push('mem:' + (navigator.deviceMemory || 0));
  components.push('touch:' + (navigator.maxTouchPoints || 0));
  components.push('platform:' + (navigator.platform || ''));

  // 4. Screen
  components.push('scr:' + screen.width + 'x' + screen.height + '@' + (window.devicePixelRatio || 1));
  components.push('cd:' + (screen.colorDepth || 0));

  // 5. Timezone
  components.push('tz:' + Intl.DateTimeFormat().resolvedOptions().timeZone);

  // 6. Audio fingerprint
  try {
    const actx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = actx.createOscillator();
    const analyser = actx.createAnalyser();
    const gain = actx.createGain();
    const proc = actx.createScriptProcessor(4096, 1, 1);
    
    gain.gain.value = 0;
    osc.type = 'triangle';
    osc.frequency.value = 10000;
    osc.connect(analyser);
    analyser.connect(proc);
    proc.connect(gain);
    gain.connect(actx.destination);
    
    const data = new Float32Array(analyser.frequencyBinCount);
    analyser.getFloatFrequencyData(data);
    const audioSum = data.reduce((a, b) => a + Math.abs(b), 0);
    components.push('audio:' + audioSum.toFixed(2));
    
    proc.disconnect();
    gain.disconnect();
    osc.disconnect();
    actx.close();
  } catch (e) {
    components.push('audio:err');
  }

  // SHA-256 hash
  const raw = components.join('|');
  const encoder = new TextEncoder();
  const data = encoder.encode(raw);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

// Cache the fingerprint for the session
let cachedFingerprint = null;

export const getDeviceFingerprint = async () => {
  if (cachedFingerprint) return cachedFingerprint;
  try {
    cachedFingerprint = await generateFingerprint();
  } catch (e) {
    cachedFingerprint = null;
  }
  return cachedFingerprint;
};
